import * as React from "react";
import { ReactChildren, ReactNode } from "react";

//region [[ Styles ]]
//endregion [[ Styles ]]
//region [[ Props ]]
//endregion [[ Props ]]
//region [[ Functions ]]
//endregion [[ Functions ]]

const RestrictAccess = (props: {
  children: JSX.Element | JSX.Element[];
  hasAccess: boolean;
}) => {
  return props.hasAccess ? (
    <>{props.children}</>
  ) : (
    <div style={{ padding: 20 }}>Sorry, You can not access this section.</div>
  );
};

export default RestrictAccess;
